import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Functions`}</p>
    <dl>
      <dt><a href="#useCartPage">useCartPage(props)</a> ⇒ <inlineCode><a href="#CartPageTalonProps">CartPageTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`This talon contains logic for a cart page component.
It performs effects and returns prop data for rendering the component.`}</p>
        <p>{`This talon performs the following effects:`}</p>
        <ul>
          <li parentName="ul">{`Manages the updating state of the cart while cart details data is being fetched`}</li>
        </ul>
      </dd>
    </dl>
    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#CartPageQueries">CartPageQueries</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL formatted string queries used in this talon.`}</p>
      </dd>
      <dt><a href="#CartPageTalonProps">CartPageTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Props data to use when rendering a cart page component.`}</p>
      </dd>
    </dl>
    <p>{`This talon contains logic for a cart page component.
It performs effects and returns prop data for rendering the component.`}</p>
    <p>{`This talon performs the following effects:`}</p>
    <ul>
      <li parentName="ul">{`Manages the updating state of the cart while cart details data is being fetched`}</li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.queries`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#CartPageQueries"
            }}><inlineCode parentName="a">{`CartPageQueries`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL queries`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useCartPage } from '@magento/peregrine/lib/talons/CartPage/useCartPage';
`}</code></pre>
    <p>{`GraphQL formatted string queries used in this talon.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-ui/lib/components/CartPage/cartPage.gql.js"
      }}>{`cartPage.gql.js`}</a>{`
for queries used in Venia`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getCartDetailsQuery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Query for getting the cart details.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Props data to use when rendering a cart page component.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cartItems`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of item objects in the cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`hasItems`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if the cart has items. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isCartUpdating`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if the cart is updating. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setIsCartUpdating`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function for setting the updating state of the cart page.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`shouldShowLoadingIndicator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if the loading indicator should be rendered. False otherwise.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/talons/CartPage/useCartPage.js"
      }}>{`pwa-studio/packages/peregrine/lib/talons/CartPage/useCartPage.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      